// extracted by mini-css-extract-plugin
export default {"aspectRatioBox":"AspectRatio-module__aspectRatioBox","aspectRatioBoxInside":"AspectRatio-module__aspectRatioBoxInside"};